import React, {
  useContext,
  useEffect,
  useState,
} from "react";
import { otherConfigOptionsAttributes } from "../../salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";
import { FeatureSelectionOptionsContext } from "./FeatureSelectionOptionsContext";
import { OptionType } from "../../manageHomepage/ManageHomePageTypes";
import { ImageIdToSVGMap } from "../../../components/newPortal/UiConfigOptions";
import { useNavigate } from "react-router-dom";
import { appSubscriptionCheck } from "../../../services/uiConfigService";

export default function AnimatedContainer(props: {
  allConfigOptions: otherConfigOptionsAttributes[];
  setAllConfigOptions: React.Dispatch<
    React.SetStateAction<otherConfigOptionsAttributes[]>
  >;
  currentRole: OptionType;
  setFeatureChangeList: React.Dispatch<React.SetStateAction<string[]>>
  standard: string | undefined;
}) {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [removingOption, setRemovingOption] = useState<string | null>(null);
  const navigate = useNavigate();

  const {
    uiConfigOptionsProp = [],
    setUiConfigOptionsProp = () => {},
  } = useContext(FeatureSelectionOptionsContext);


  useEffect(() => {
    props.setAllConfigOptions([...uiConfigOptionsProp]);
  }, [uiConfigOptionsProp]);

  const handleAddOptions = () => {
    console.log('Adding options:', selectedOptions);
    const optionsToAdd = [...selectedOptions];
    props.setFeatureChangeList((prev) => {
      for (let option of optionsToAdd) {
        const index = prev.indexOf(option);
        if (index !== -1) {
          prev.splice(index, 1);
        } else {
          prev.push(option);
        }
      }
      return [...prev];
    });
    setUiConfigOptionsProp((prevState: otherConfigOptionsAttributes[]) =>
      prevState.map((opt: otherConfigOptionsAttributes) =>
        selectedOptions.includes(opt.id)
          ? { ...opt, isSelected: true, action: "added" }
          : opt
      )
    );
    setSelectedOptions([]);
  };

  const handleCheckboxChange = (optionId: string) => {
    console.log('Checkbox changed for:', optionId);
    setSelectedOptions(
      (prev) =>
        prev?.includes(optionId)
          ? prev?.filter((id) => id !== optionId)
          : [...prev, optionId]
    );
  };
  useEffect(() => {
    setSelectedOptions([]);
    }, [props.currentRole]);

  const handleRemoveOption = (option: otherConfigOptionsAttributes) => {
    props.setFeatureChangeList((prev) => {
      const index = prev.indexOf(option.id);
      if (index !== -1) {
        prev.splice(index, 1);
      } else {
        prev.push(option.id);
      }
      return [...prev];
    });

    setRemovingOption(option.id);

    setTimeout(() => {
      setUiConfigOptionsProp((prevState: otherConfigOptionsAttributes[]) =>
        prevState.map((opt: otherConfigOptionsAttributes) =>
          opt.id === option.id
            ? { ...opt, isSelected: false, action: "removed" }
            : opt
        )
      );
      setRemovingOption(null);
    }, 400);
  };

  return (
    <div>
      <h2 style={{ 
        fontSize: "18px", 
        fontWeight: 500,
        color: "#333333",
        marginBottom: "16px"
      }}>
        Feature selection
      </h2>
      
      <div
        style={{
          display: "flex",
          gap: "32px",
          height: "100%",
        }}
      >
        {/* Left Column - Existing Features */}
        <div
          style={{
            width: "48%",
            backgroundColor: "#f5f5f5",
            borderRadius: "12px",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "20px 24px",
              borderBottom: "1px solid #e0e0e0",
              backgroundColor: "#f5f5f5"
            }}
          >
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "16px",
                fontWeight: 500,
                color: "#333333",
              }}
            >
              Existing features
            </h3>
            <p
              style={{
                margin: "0",
                fontSize: "14px",
                color: "#666666",
                fontWeight: 400
              }}
            >
              Selected features by you
            </p>
          </div>

          {/* Features List */}
          <div
            style={{
              flex: "1",
              overflowY: "auto",
              padding: "0 24px 24px 24px",
              backgroundColor: "#f5f5f5",
              maxHeight: "352px",
            }}
          >
            {/* Non-mandatory selected features */}
            {uiConfigOptionsProp
              ?.filter(
                (option) =>
                  option.isSelected &&
                  !option.isMandatory 
                  && appSubscriptionCheck(option,props.standard)
              )
              ?.map((option) => (
                <div
                  key={option.id}
                  className={
                    removingOption === option.id ? "exitAnimation" : ""
                  }
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "16px 0",
                    borderBottom: "1px solid #e0e0e0"
                  }}
                >
                  {/* Feature Icon */}
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <img
                      src={ImageIdToSVGMap[option.icon ?? "default"]}
                      alt={`${option.id} icon`}
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </div>

                  {/* Feature Info */}
                  <div style={{ flex: "1" }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#333333",
                        marginBottom: "4px",
                      }}
                    >
                      {option.id}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666666",
                        lineHeight: "1.4",
                      }}
                    >
                      {option.description}
                    </div>
                  </div>

                  {/* Green Checkbox */}
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      backgroundColor: "#10b981",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: "16px",
                      cursor: "pointer",
                    }}
                    onClick={() => handleRemoveOption(option)}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M10 3L4.5 8.5L2 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              ))}

            {/* Mandatory selected features */}
            {uiConfigOptionsProp
              ?.filter(
                (option) =>
                  option.isSelected &&
                  option.isMandatory &&
                  appSubscriptionCheck(option,props.standard)
              )
              ?.map((option) => (
                <div
                  key={option.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "16px 0",
                    borderBottom: "1px solid #e0e0e0"
                  }}
                >
                  {/* Feature Icon */}
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: "#ffffff",
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <img
                      src={ImageIdToSVGMap[option.icon ?? "default"]}
                      alt={`${option.id} icon`}
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    />
                  </div>

                  {/* Feature Info */}
                  <div style={{ flex: "1" }}>
                    <div
                      style={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#333333",
                        marginBottom: "4px",
                      }}
                    >
                      {option.id}
                    </div>
                    <div
                      style={{
                        fontSize: "12px",
                        color: "#666666",
                        lineHeight: "1.4",
                      }}
                    >
                      {option.description}
                    </div>
                  </div>

                  {/* Green Checkbox (disabled for mandatory) */}
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      backgroundColor: "#10b981",
                      borderRadius: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: "16px",
                      opacity: "0.6",
                      cursor: "not-allowed",
                    }}
                  >
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                    >
                      <path
                        d="M10 3L4.5 8.5L2 6"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              ))}
          </div>
        </div>

        {/* Right Column - Additional Features */}
        <div
          style={{
            width: "48%",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            border: "2px solid #10b981",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            position: "relative", // Add relative positioning for absolute positioning of sticky button
            height: "450px" // Fixed height to ensure consistent positioning
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: "20px 24px",
              borderBottom: "1px solid #e0e0e0",
              backgroundColor: "#ffffff"
            }}
          >
            <h3
              style={{
                margin: "0 0 8px 0",
                fontSize: "16px",
                fontWeight: 500,
                color: "#333333",
              }}
            >
              Additional features
            </h3>
            <p
              style={{
                margin: "0",
                fontSize: "14px",
                color: "#666666",
                fontWeight: 400
              }}
            >
              Select the additional features you want to add
            </p>
          </div>

          {/* Features List Container */}
          <div
            style={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden"
            }}
          >
            {/* Scrollable Features List */}
            <div
              style={{
                flex: "1",
                overflowY: "auto",
                padding: "0 24px 80px 24px", // Add bottom padding to prevent overlap with sticky button
                backgroundColor: "#ffffff",
                maxHeight: "272px", // Reduced to account for sticky button space
              }}
            >
              {props.allConfigOptions
                ?.filter(
                  (option) =>
                    !option.isMandatory &&
                    !option.isSelected
                    && appSubscriptionCheck(option,props.standard)
                )
                ?.map((option) => (
                  <div
                    key={option.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "16px 0",
                      borderBottom: "1px solid #f0f0f0",
                      cursor: "pointer",
                    }}
                    onClick={() => handleCheckboxChange(option.id)}
                  >
                    {/* Feature Icon */}
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "16px",
                        border: "1px solid #e0e0e0",
                      }}
                    >
                      <img
                        src={ImageIdToSVGMap[option.icon ?? "default"]}
                        alt={`${option.id} icon`}
                        style={{
                          width: "20px",
                          height: "20px",
                        }}
                      />
                    </div>

                    {/* Feature Info */}
                    <div style={{ flex: "1" }}>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: 500,
                          color: "#333333",
                          marginBottom: "4px",
                        }}
                      >
                        {option.id}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                          color: "#666666",
                          lineHeight: "1.4",
                        }}
                      >
                        {option.description}
                      </div>
                    </div>

                    {/* Checkbox */}
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: selectedOptions.includes(option.id) ? "#10b981" : "#ffffff",
                        borderRadius: "4px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginLeft: "16px",
                        border: selectedOptions.includes(option.id) ? "none" : "2px solid #e0e0e0",
                        cursor: "pointer",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCheckboxChange(option.id);
                      }}
                    >
                      {selectedOptions.includes(option.id) && (
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                        >
                          <path
                            d="M10 3L4.5 8.5L2 6"
                            stroke="white"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      )}
                    </div>
                  </div>
                ))}
            </div>

            {/* Sticky Add Button and Preview Link - Now absolutely positioned */}
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 999,
                backgroundColor: "#ffffff",
                padding: "16px 24px",
                borderTop: "1px solid #f0f0f0",
                display: "flex",
                flexDirection: "row-reverse",
                justifyContent: "flex-end",
                alignItems: "center"
              }}
            >
              {selectedOptions.length > 0 && (
                <button
                  onClick={handleAddOptions}
                  style={{
                    backgroundColor: "#10b981",
                    color: "#ffffff",
                    border: "none",
                    padding: "12px 0px",
                    marginLeft: "auto",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 500,
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    minWidth: "120px"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#059669";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#10b981";
                  }}
                >
                  Add ({selectedOptions.length})
                </button>
              )}
              <div
                onClick={() => navigate("/dashboard/settings/feature-preview")}
                style={{
                  color: "#4CAF50",
                  fontSize: "14px",
                  textDecoration: "none",
                  fontWeight: 400,
                  cursor: "pointer"
                }}
              >
                Visit feature preview page
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}